module.exports = __webpack_public_path__ + "static/img/smartProduct3.6a5a6407.png";